module.exports = __webpack_public_path__ + "img/course-slider-1.22c20f8b.png";